import gsap from 'gsap';
export function DebugHint(txt: string) {
    if (!window.debugHint) return;
    new CustomConsole(txt);
}
export function DebugGA(txt: string) {
    if (!window.debugGA) return;
    new CustomConsole(txt);
}
class CustomConsole {
    constructor(txt: string) {
        const consoleContainer = this.createMainContainer();

        const hint = document.createElement('p');
        setTimeout(
            (e) => {
                gsap.to(hint, { duration: 3, opacity: 0 }).then(() => {
                    e.remove();
                });
            },
            2000,
            hint
        );
        hint.innerText = txt;

        hint.style.fontSize = '20px;';
        hint.style.background = 'rgba(0,0,0,0.6)';
        hint.style.fontWeight = '900';
        hint.style.color = '#FFF';
        hint.style.padding = '3px 10px';
        hint.style.margin = '0';
        consoleContainer.append(hint);
    }
    createMainContainer() {
        let mainContainer = document.getElementById('customConsole');
        if (!mainContainer) {
            mainContainer = document.createElement('div');
            mainContainer.id = 'customConsole';
            mainContainer.style.position = 'fixed';
            mainContainer.style.top = '0';
            mainContainer.style.left = '0';
            mainContainer.style.display = 'flex';
            mainContainer.style.flexDirection = 'column';
            mainContainer.style.justifyContent = 'flex-start';
            mainContainer.style.alignItems = 'flex-start';
            mainContainer.style.zIndex = '100';
            document.body.append(mainContainer);
        }
        return mainContainer;
    }
}
